import React from 'react';

export default function LocalOpsDefaultProofVisual({
  title,
  regionLabel,
  rewardLabel,
  completedAtLabel,
  completionSpeedLabel,
  helperName,
}) {
  const facts = [
    regionLabel ? { label: 'Where', value: regionLabel } : null,
    rewardLabel ? { label: 'Reward', value: rewardLabel } : null,
    completedAtLabel ? { label: 'Completed', value: completedAtLabel } : null,
    completionSpeedLabel
      ? { label: 'Speed', value: completionSpeedLabel }
      : null,
  ].filter(Boolean);

  return (
    <section
      className="localops-default-proof-visual"
      data-testid="localops-default-proof-visual"
      aria-label="Privacy-safe LocalOps proof visual"
    >
      <div className="localops-default-proof-visual__grid" aria-hidden="true" />
      <div className="localops-default-proof-visual__topline">
        <span>JG LocalOps</span>
        <span>Action Proof Receipt</span>
      </div>

      <div className="localops-default-proof-visual__seal" aria-hidden="true">
        <svg viewBox="0 0 48 48" focusable="false" role="img">
          <circle cx="24" cy="24" r="21" />
          <path d="M14 24.5 21.2 31 34.5 17" />
        </svg>
      </div>

      <div className="localops-default-proof-visual__content">
        <p className="localops-default-proof-visual__kicker">
          Verified LocalOps Completion
        </p>
        <h3>{title}</h3>
        {facts.length ? (
          <dl className="localops-default-proof-visual__facts">
            {facts.map((fact) => (
              <div key={fact.label}>
                <dt>{fact.label}</dt>
                <dd>{fact.value}</dd>
              </div>
            ))}
          </dl>
        ) : null}
        {helperName ? (
          <p className="localops-default-proof-visual__helper">
            Completed by {helperName}
          </p>
        ) : null}
      </div>

      <div className="localops-default-proof-visual__footer">
        <span>Privacy-safe proof visual</span>
        <span>No public task photo shown</span>
        <strong>Local help. Real people. Action nearby.</strong>
      </div>
    </section>
  );
}
